import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function CtaLink({ cta, variant, testId }) {
  if (!cta) return null;
  const cls = variant === "primary" ? "btn-primary" : "btn-outline";
  const isExternal = typeof cta.to === "string" && /^https?:\/\//.test(cta.to);
  if (isExternal) {
    return (
      <a href={cta.to} target="_blank" rel="noreferrer" className={cls} data-testid={testId}>
        {cta.label}
      </a>
    );
  }
  return (
    <Link to={cta.to} className={cls} data-testid={testId}>
      {cta.label}
    </Link>
  );
}

export default function PageHero({ overline, title, subtitle, image, ctaPrimary, ctaSecondary, testId }) {
  return (
    <section className="pt-36 md:pt-40 pb-20 relative overflow-hidden" data-testid={testId || "page-hero"}>
      <div
        aria-hidden
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(60% 60% at 85% 15%, rgba(215,20,26,0.08) 0%, transparent 60%), #F8F7F4",
        }}
      />
      <div className="container-sp grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          {overline && <div className="overline">{overline}</div>}
          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#0D1B2A] mt-4 leading-[1.05] tracking-tight"
          >
            {title}
          </motion.h1>
          {subtitle && (
            <p className="mt-6 text-lg text-[#4A5568] leading-relaxed max-w-xl">{subtitle}</p>
          )}
          {(ctaPrimary || ctaSecondary) && (
            <div className="mt-8 flex flex-wrap gap-3">
              <CtaLink cta={ctaPrimary} variant="primary" testId="pagehero-cta-primary" />
              <CtaLink cta={ctaSecondary} variant="outline" testId="pagehero-cta-secondary" />
            </div>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="rounded-[2rem] overflow-hidden border border-[#E5E3D8] shadow-xl"
            >
              <img src={image} alt={title} className="w-full h-[460px] object-cover" />
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
}
